import React from 'react';
import {
  Navigate,
  Outlet,
  createBrowserRouter,
} from 'react-router-dom';
// import Layout from 'components/Layout';
import NotFound from 'components/Error404';

import AuthPage from 'pages/Auth/auth';
import App from 'App';
import customerRoutes from 'routes/routes.customer';
import EmailConfirmPage from 'pages/customer/settings/users/EmailConfirmPage/EmailConfirmPage';
import MaintenancePage from 'pages/Maintenance/Maintenance';
import PasswordResetPage from 'pages/password-reset/password-reset-page';
import PasswordSetPage from 'pages/password-set/password-set-page';
import ChangeLoginConfirmPage from 'pages/change-login-confirm/change-login-confirm-page';
import DeactivationConfirmPage from 'pages/deactivation-confirm/deactivation-confirm-page';
import TrustedEmailConfirmPage from 'pages/trusted-email-confirm/TrustedEmailConfirmPage';
import RegistrationPage from 'pages/registration/registration-page';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        path: '',
        element: <AuthPage />,
      },
      {
        path: 'auth',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'maintenance',
        element: <MaintenancePage />,
      },
      {
        path: 'notification-email',
        element: <Outlet />,
        children: [
          {
            path: ':token',
            element: <EmailConfirmPage />,
          },
        ],
      },
      {
        path: 'registration',
        element: <RegistrationPage />,
      },
      {
        path: 'password-reset',
        element: <PasswordResetPage />,
      },
      {
        path: 'activate',
        element: <PasswordSetPage />,
      },
      {
        path: 'change-login',
        element: <ChangeLoginConfirmPage />,
      },
      {
        path: 'user-deactivation',
        element: <DeactivationConfirmPage />,
      },
      {
        path: 'verify-trusted-email',
        element: <TrustedEmailConfirmPage />,
      },
      ...customerRoutes,
    ],
  },
]);

export default router;
